import { render, staticRenderFns } from "./ClientColumnTemplate.vue?vue&type=template&id=935bf4a8&scoped=true"
import script from "./ClientColumnTemplate.vue?vue&type=script&lang=js"
export * from "./ClientColumnTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "935bf4a8",
  null
  
)

export default component.exports